import {Injectable}  from '@angular/core';
import {HttpClient}  from '@angular/common/http';
import {Observable}  from 'rxjs';
import {environment} from '@src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FormCategoryService
{
    private baseUrl: string;

    public constructor(private http: HttpClient)
    {
        this.baseUrl = environment.apiUrl;
    }

    public list(kind: 'work' | 'pre_work' | null = null, pageSize: number = 100): Observable<any>
    {
        const filter = kind ? `&filter[kind]=${kind}` : '';

        return this.http.get(`${this.baseUrl}/form-categories?page[size]=${pageSize}${filter}`);
    }

    public create(data: any): Observable<any>
    {
        return this.http.post(`${this.baseUrl}/form-categories`, data);
    }

    public update(id: number, data: any): Observable<any>
    {
        return this.http.put(`${this.baseUrl}/form-categories/${id}`, data);
    }

    public delete(id: number): Observable<any>
    {
        return this.http.delete(`${this.baseUrl}/form-categories/${id}`);
    }
}
